export const ONBOARDING_INTRO = {
  title: 'Уточним пару деталей',
  subtitle:
    'Ответьте на два коротких вопроса — это поможет подобрать настройки под задачи вашей сети.',
};
